module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.title) + " "), (_vm.data && !_vm.loading) ? _c('span', [_vm._v("(" + _vm._s(_vm.data.total_count) + " results)")]) : _vm._e()]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typing),
      expression: "typing"
    }]
  }, [_vm._v("Stop typing to search...")]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._v("Loading...")]), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('h5', [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")]), _vm._v(" " + _vm._s(_vm.page) + " / " + _vm._s(_vm.totalPage) + " "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('table', {
    staticClass: "u-full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.data.items), function(x) {
    return _c('tr', [_c('th', [_c('a', {
      attrs: {
        "href": x.html_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(x.name))])]), _vm._v(" "), _c('th', [_c('a', {
      attrs: {
        "href": x.owner.html_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(x.owner.login))])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(x.stargazers_count))])])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Owner")]), _vm._v(" "), _c('th', [_vm._v("Star")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ce518fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 392
// module chunks = 1